
(() => {
  const USS_CART = {
    gearHandle: 'hockey-gear',
    maxGearItems: 10,
    gearProducts: null,
    gearHandleSet: new Set(),
    scheduled: false
  };

  const css = String.raw`
  :root {
    --uss-cart-ink: #17212b;
    --uss-cart-muted: #6d7881;
    --uss-cart-line: #dbe1e5;
    --uss-cart-soft: #f5f7f8;
    --uss-cart-blue: #eef7fb;
    --uss-cart-blue-strong: #3182a7;
    --uss-cart-green: #18864b;
    --uss-cart-green-dark: #126f3d;
  }

  /* -------------------------------------------------------
     CHECKOUT BUTTONS — remove Dawn pseudo outlines
  ------------------------------------------------------- */
  .cart__checkout-button,
  #checkout,
  #CartDrawer-Checkout,
  .uss-cart-direct-checkout,
  .cart-notification__links button[name="checkout"] {
    border: 0 !important;
    border-radius: 10px !important;
    background: var(--uss-cart-green) !important;
    color: #fff !important;
    box-shadow: 0 7px 18px rgba(24,134,75,.20) !important;
    outline: none !important;
    text-decoration: none !important;
    font-weight: 850 !important;
  }

  .cart__checkout-button::before,
  .cart__checkout-button::after,
  #checkout::before,
  #checkout::after,
  #CartDrawer-Checkout::before,
  #CartDrawer-Checkout::after,
  .uss-cart-direct-checkout::before,
  .uss-cart-direct-checkout::after,
  .cart-notification__links button[name="checkout"]::before,
  .cart-notification__links button[name="checkout"]::after {
    content: none !important;
    display: none !important;
    box-shadow: none !important;
    outline: none !important;
  }

  .cart__checkout-button:hover,
  #checkout:hover,
  #CartDrawer-Checkout:hover,
  .uss-cart-direct-checkout:hover,
  .cart-notification__links button[name="checkout"]:hover {
    background: var(--uss-cart-green-dark) !important;
  }

  .cart__checkout-button:focus-visible,
  #checkout:focus-visible,
  #CartDrawer-Checkout:focus-visible,
  .uss-cart-direct-checkout:focus-visible,
  .cart-notification__links button[name="checkout"]:focus-visible {
    outline: 2px solid var(--uss-cart-green) !important;
    outline-offset: 3px !important;
  }

  /* -------------------------------------------------------
     CART DRAWER
  ------------------------------------------------------- */
  cart-drawer .drawer__inner {
    width: min(44rem, calc(100vw - 10px)) !important;
    max-width: 100% !important;
    padding: 0 !important;
    border: 0 !important;
    border-left: 1px solid rgba(17,33,43,.10) !important;
    background: #fff !important;
    box-shadow: -18px 0 55px rgba(17,33,43,.16) !important;
  }

  cart-drawer .drawer__header {
    min-height: 78px;
    padding: 16px 20px !important;
    border-bottom: 1px solid #e7ecef;
    background: #fff;
  }

  cart-drawer .drawer__heading {
    margin: 0 !important;
    color: var(--uss-cart-ink);
    font-size: 22px !important;
    font-weight: 850 !important;
    letter-spacing: -.025em;
  }

  cart-drawer .drawer__close {
    position: static !important;
    display: grid !important;
    place-items: center;
    width: 38px !important;
    height: 38px !important;
    min-width: 38px !important;
    min-height: 38px !important;
    padding: 0 !important;
    border: 1px solid var(--uss-cart-line) !important;
    border-radius: 50% !important;
    background: #fff !important;
    color: #56636c !important;
  }

  cart-drawer cart-drawer-items {
    padding: 0 18px;
    scrollbar-width: thin;
    scrollbar-color: #c8d1d6 transparent;
  }

  cart-drawer .cart-items thead {
    display: none !important;
  }

  cart-drawer .cart-item {
    display: grid !important;
    grid-template-columns: 88px minmax(0,1fr) auto !important;
    grid-template-areas:
      "media details total"
      "media quantity quantity" !important;
    gap: 8px 12px !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 17px 0 !important;
    border-bottom: 1px solid #e8edef;
  }

  cart-drawer .cart-item:last-child {
    border-bottom: 0;
  }

  cart-drawer .cart-item__media {
    grid-area: media !important;
    width: 88px !important;
    padding: 0 !important;
  }

  cart-drawer .cart-item__image {
    width: 88px !important;
    max-width: 88px !important;
    height: 88px !important;
    object-fit: contain !important;
    border: 1px solid #e2e8eb;
    border-radius: 11px;
    background: #fff;
  }

  cart-drawer .cart-item__details {
    grid-area: details !important;
    width: auto !important;
    min-width: 0 !important;
    padding: 1px 0 0 !important;
  }

  cart-drawer .cart-item__name {
    color: var(--uss-cart-ink) !important;
    font-size: 13px !important;
    font-weight: 800 !important;
    line-height: 1.3 !important;
    text-decoration: none !important;
  }

  cart-drawer .product-option {
    margin-top: 3px !important;
    color: var(--uss-cart-muted) !important;
    font-size: 10px !important;
    line-height: 1.35 !important;
  }

  cart-drawer .cart-item__totals {
    grid-area: total !important;
    display: flex !important;
    align-items: flex-start !important;
    justify-content: flex-end !important;
    padding: 2px 0 0 8px !important;
  }

  cart-drawer .cart-item__price-wrapper .price,
  cart-drawer .cart-item__final-price {
    color: var(--uss-cart-ink) !important;
    font-size: 12px !important;
    font-weight: 850 !important;
  }

  cart-drawer .cart-item__quantity {
    grid-area: quantity !important;
    padding: 2px 0 0 !important;
  }

  cart-drawer .cart-item__quantity-wrapper {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
  }

  cart-drawer .quantity {
    width: 102px !important;
    min-height: 32px !important;
    border: 1px solid #d7dfe3 !important;
    border-radius: 8px !important;
    background: #fff !important;
  }

  cart-drawer .quantity::before,
  cart-drawer .quantity::after {
    display: none !important;
  }

  cart-drawer .quantity__button {
    width: 31px !important;
    min-width: 31px !important;
  }

  cart-drawer cart-remove-button {
    margin: 0 !important;
  }

  cart-drawer cart-remove-button .button {
    width: 32px !important;
    height: 32px !important;
    min-width: 32px !important;
    min-height: 32px !important;
    padding: 0 !important;
    border: 1px solid #e1e6e9 !important;
    border-radius: 8px !important;
    background: #fff !important;
    color: #7b858c !important;
  }

  cart-drawer .drawer__footer {
    padding: 15px 18px 18px !important;
    border-top: 1px solid #e2e8eb !important;
    background: #fff !important;
    box-shadow: 0 -8px 24px rgba(17,33,43,.035);
  }

  cart-drawer .totals {
    justify-content: space-between !important;
  }

  cart-drawer .totals__total {
    color: var(--uss-cart-muted) !important;
    font-size: 12px !important;
    font-weight: 700 !important;
  }

  cart-drawer .totals__total-value {
    color: var(--uss-cart-ink) !important;
    font-size: 21px !important;
    font-weight: 850 !important;
    letter-spacing: -.03em;
  }

  cart-drawer .tax-note {
    margin: 6px 0 12px !important;
    color: #839099 !important;
    font-size: 9px !important;
    line-height: 1.4 !important;
    text-align: left !important;
  }

  cart-drawer .cart__checkout-button {
    width: 100% !important;
    max-width: none !important;
    min-height: 50px !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    font-size: 13px !important;
  }

  cart-drawer .cart__dynamic-checkout-buttons,
  cart-drawer .additional-checkout-buttons {
    display: none !important;
  }

  /* -------------------------------------------------------
     FULL CART PAGE
  ------------------------------------------------------- */
  cart-items {
    display: block;
    background: #fff;
    color: var(--uss-cart-ink);
  }

  cart-items .page-width {
    max-width: 1140px;
  }

  cart-items .title-wrapper-with-link {
    display: flex !important;
    align-items: flex-end !important;
    justify-content: space-between !important;
    gap: 24px !important;
    margin: 0 0 24px !important;
    padding-bottom: 17px;
    border-bottom: 1px solid #e6ecef;
  }

  cart-items .title.title--primary {
    margin: 0 !important;
    color: var(--uss-cart-ink);
    font-size: clamp(30px,4vw,44px) !important;
    font-weight: 850 !important;
    letter-spacing: -.045em;
    line-height: 1;
  }

  cart-items .underlined-link {
    color: #58666f !important;
    font-size: 12px !important;
    font-weight: 750 !important;
    text-underline-offset: 4px;
  }

  cart-items .cart-items,
  cart-items .cart-items tbody {
    display: block !important;
    width: 100% !important;
  }

  cart-items .cart-items thead {
    display: none !important;
  }

  cart-items .cart-item {
    display: grid !important;
    grid-template-columns: 128px minmax(0,1fr) 150px 120px !important;
    grid-template-areas: "media details quantity total" !important;
    align-items: center !important;
    gap: 22px !important;
    width: 100% !important;
    margin: 0 0 14px !important;
    padding: 18px !important;
    border: 1px solid var(--uss-cart-line);
    border-radius: 15px;
    background: #fff;
    box-shadow: 0 5px 18px rgba(23,33,43,.035);
  }

  cart-items .cart-item__media {
    grid-area: media !important;
    width: 128px !important;
  }

  cart-items .cart-item__image-container {
    display: flex !important;
    align-items: center;
    justify-content: center;
    width: 128px !important;
    height: 128px !important;
    overflow: hidden;
    border: 1px solid #e2e8eb !important;
    border-radius: 12px !important;
    background: #fff !important;
  }

  cart-items .cart-item__image {
    width: 100% !important;
    max-width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
  }

  cart-items .cart-item__details {
    grid-area: details !important;
    width: auto !important;
    min-width: 0 !important;
    font-size: 14px !important;
  }

  cart-items .cart-item__name {
    display: block;
    width: fit-content;
    max-width: 560px;
    color: var(--uss-cart-ink) !important;
    font-size: 16px !important;
    font-weight: 850 !important;
    line-height: 1.28 !important;
    text-decoration: none !important;
  }

  cart-items .product-option {
    margin: 2px 0 0 !important;
    color: var(--uss-cart-muted) !important;
    font-size: 11px !important;
    line-height: 1.45 !important;
  }

  cart-items .cart-item__quantity {
    grid-area: quantity !important;
    padding: 0 !important;
  }

  cart-items .cart-item__quantity-wrapper {
    display: flex !important;
    align-items: center !important;
    gap: 9px !important;
  }

  cart-items .cart-quantity.quantity {
    width: 112px !important;
    min-height: 38px !important;
    border: 1px solid #d5dde1 !important;
    border-radius: 9px !important;
    background: #fff !important;
  }

  cart-items .cart-quantity.quantity::before,
  cart-items .cart-quantity.quantity::after {
    display: none !important;
  }

  cart-items cart-remove-button .button {
    width: 38px !important;
    height: 38px !important;
    min-width: 38px !important;
    min-height: 38px !important;
    margin: 0 !important;
    padding: 0 !important;
    border: 1px solid #dfe5e8 !important;
    border-radius: 9px !important;
    background: #fff !important;
    color: #7b858c !important;
  }

  cart-items .cart-item__totals {
    grid-area: total !important;
    display: flex !important;
    justify-content: flex-end !important;
    text-align: right !important;
  }

  cart-items .cart-item__price-wrapper .price,
  cart-items .cart-item__final-price {
    color: var(--uss-cart-ink) !important;
    font-size: 15px !important;
    font-weight: 850 !important;
  }

  /* Cart footer / summary */
  #main-cart-footer {
    background: #fff !important;
  }

  #main-cart-footer .cart__footer {
    max-width: 1100px;
    margin: 0 auto;
  }

  #main-cart-footer .cart__blocks {
    width: min(100%, 430px) !important;
    margin-left: auto !important;
    padding: 18px 20px 20px !important;
    border: 1px solid var(--uss-cart-line);
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 10px 30px rgba(23,33,43,.06);
  }

  #main-cart-footer .totals {
    display: flex !important;
    align-items: baseline !important;
    justify-content: space-between !important;
    gap: 20px;
  }

  #main-cart-footer .totals__total {
    color: var(--uss-cart-muted) !important;
    font-size: 13px !important;
    font-weight: 700 !important;
  }

  #main-cart-footer .totals__total-value {
    color: var(--uss-cart-ink) !important;
    font-size: 25px !important;
    font-weight: 850 !important;
    letter-spacing: -.035em;
  }

  #main-cart-footer .tax-note {
    display: block;
    margin: 8px 0 14px !important;
    color: #7a858d !important;
    font-size: 10px !important;
    line-height: 1.45 !important;
    text-align: left !important;
  }

  #main-cart-footer .cart__checkout-button {
    width: 100% !important;
    max-width: none !important;
    min-height: 54px !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    font-size: 14px !important;
  }

  /* -------------------------------------------------------
     ADD-ON LINES
  ------------------------------------------------------- */
  .uss-cart-addon-badge {
    display: inline-flex;
    align-items: center;
    width: fit-content;
    min-height: 21px;
    margin-top: 6px;
    padding: 0 7px;
    border-radius: 999px;
    background: #eaf7ef;
    color: var(--uss-cart-green);
    font-size: 8px;
    font-weight: 850;
    letter-spacing: .05em;
    text-transform: uppercase;
  }

  .uss-cart-addon-for {
    display: block;
    max-width: 240px;
    margin-top: 3px;
    overflow: hidden;
    color: #78848c;
    font-size: 9px;
    font-weight: 650;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  cart-drawer .uss-cart-item--addon {
    grid-template-columns: 72px minmax(0,1fr) auto !important;
    margin: 6px 0 !important;
    padding: 12px 9px !important;
    border: 1px solid #d7eadf !important;
    border-radius: 12px;
    background: #f8fcf9;
  }

  cart-drawer .uss-cart-item--addon .cart-item__media {
    width: 72px !important;
  }

  cart-drawer .uss-cart-item--addon .cart-item__image {
    width: 72px !important;
    max-width: 72px !important;
    height: 72px !important;
    border-color: #dce8e0;
  }

  cart-items .uss-cart-item--addon {
    width: calc(100% - 34px) !important;
    margin-left: 34px !important;
    grid-template-columns: 100px minmax(0,1fr) 135px 105px !important;
    padding: 14px 16px !important;
    border-color: #d7eadf !important;
    background: #f8fcf9 !important;
    box-shadow: none !important;
  }

  cart-items .uss-cart-item--addon .cart-item__media {
    width: 100px !important;
  }

  cart-items .uss-cart-item--addon .cart-item__image-container {
    width: 100px !important;
    height: 100px !important;
    border-color: #dce8e0 !important;
  }

  cart-items .uss-cart-item--addon .cart-item__price-wrapper .price,
  cart-items .uss-cart-item--addon .cart-item__final-price,
  cart-drawer .uss-cart-item--addon .cart-item__price-wrapper .price,
  cart-drawer .uss-cart-item--addon .cart-item__final-price {
    color: var(--uss-cart-green) !important;
  }

  /* Main displayed add-on total gets a + prefix */
  .uss-cart-item--addon .cart-item__totals .price:not(s)::before {
    content: "+";
  }

  /* -------------------------------------------------------
     CART NOTIFICATION
  ------------------------------------------------------- */
  cart-notification .cart-notification {
    overflow: hidden;
    border: 1px solid var(--uss-cart-line) !important;
    border-radius: 16px !important;
    background: #fff !important;
    box-shadow: 0 20px 55px rgba(17,33,43,.18) !important;
  }

  cart-notification .cart-notification__header {
    padding: 16px 18px !important;
    border-bottom: 1px solid #e7ecef;
  }

  cart-notification .cart-notification__heading {
    color: var(--uss-cart-ink) !important;
    font-weight: 850 !important;
  }

  cart-notification .cart-notification__links {
    display: grid !important;
    gap: 9px !important;
    padding: 14px 18px 18px !important;
  }

  cart-notification .cart-notification__links .button {
    min-height: 48px !important;
    border-radius: 9px !important;
    font-size: 13px !important;
    font-weight: 850 !important;
  }

  /* -------------------------------------------------------
     HOCKEY GEAR CAROUSEL
  ------------------------------------------------------- */
  .uss-gear-carousel {
    --uss-card-width: 178px;
    margin: 26px 0 6px;
    padding: 22px;
    border: 1px solid var(--uss-cart-line);
    border-radius: 16px;
    background: #f8fafb;
  }

  cart-drawer .uss-gear-carousel {
    --uss-card-width: 122px;
    margin: 9px 0 17px;
    padding: 14px 0 2px;
    border: 0;
    border-top: 1px solid #e8edef;
    border-radius: 0;
    background: transparent;
  }

  .uss-gear-carousel__heading {
    display: flex;
    align-items: end;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 13px;
  }

  .uss-gear-carousel__kicker {
    display: block;
    margin-bottom: 2px;
    color: var(--uss-cart-blue-strong);
    font-size: 9px;
    font-weight: 850;
    letter-spacing: .09em;
    text-transform: uppercase;
  }

  .uss-gear-carousel__heading h2 {
    margin: 0;
    color: var(--uss-cart-ink);
    font-size: 19px;
    font-weight: 850;
    letter-spacing: -.025em;
  }

  cart-drawer .uss-gear-carousel__heading h2 {
    font-size: 15px;
  }

  .uss-gear-carousel__heading a {
    color: #5f6d76;
    font-size: 10px;
    font-weight: 750;
    text-underline-offset: 3px;
  }

  .uss-gear-carousel__track {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: var(--uss-card-width);
    gap: 11px;
    overflow-x: auto;
    overscroll-behavior-inline: contain;
    padding: 1px 1px 9px;
    scroll-snap-type: x proximity;
    scrollbar-width: thin;
    scrollbar-color: #cad3d8 transparent;
  }

  .uss-gear-carousel__card {
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;
    border: 1px solid #dce3e7;
    border-radius: 12px;
    background: #fff;
    color: var(--uss-cart-ink);
    text-decoration: none;
    scroll-snap-align: start;
    box-shadow: 0 4px 14px rgba(23,33,43,.035);
  }

  .uss-gear-carousel__image {
    display: grid;
    place-items: center;
    width: 100%;
    aspect-ratio: 1 / 1;
    overflow: hidden;
    border-bottom: 1px solid #edf0f2;
    background: #fff;
  }

  .uss-gear-carousel__image img {
    width: 100%;
    height: 100%;
    padding: 9px;
    object-fit: contain;
  }

  .uss-gear-carousel__copy {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 4px;
    padding: 9px 9px 6px;
  }

  .uss-gear-carousel__copy strong {
    display: -webkit-box;
    overflow: hidden;
    color: var(--uss-cart-ink);
    font-size: 10px;
    font-weight: 800;
    line-height: 1.27;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .uss-gear-carousel__copy span {
    color: var(--uss-cart-ink);
    font-size: 11px;
    font-weight: 850;
  }

  .uss-gear-carousel__view {
    margin: 0 9px 9px;
    padding: 7px;
    border-radius: 8px;
    background: #eef3f5;
    color: #53616a;
    font-size: 8px;
    font-weight: 800;
    text-align: center;
  }

  /* -------------------------------------------------------
     RESPONSIVE
  ------------------------------------------------------- */
  @media screen and (max-width: 900px) {
    cart-items .cart-item {
      grid-template-columns: 112px minmax(0,1fr) 110px !important;
      grid-template-areas:
        "media details total"
        "media quantity quantity" !important;
      align-items: start !important;
      gap: 12px 16px !important;
    }

    cart-items .cart-item__media,
    cart-items .cart-item__image-container {
      width: 112px !important;
    }

    cart-items .cart-item__image-container {
      height: 112px !important;
    }

    cart-items .uss-cart-item--addon {
      grid-template-columns: 88px minmax(0,1fr) 96px !important;
      grid-template-areas:
        "media details total"
        "media quantity quantity" !important;
    }
  }

  @media screen and (max-width: 749px) {
    cart-drawer .drawer__inner {
      width: calc(100vw - 6px) !important;
    }

    cart-drawer cart-drawer-items {
      padding: 0 13px;
    }

    cart-drawer .cart-item {
      grid-template-columns: 76px minmax(0,1fr) auto !important;
      gap: 7px 10px !important;
      padding: 14px 0 !important;
    }

    cart-drawer .cart-item__media {
      width: 76px !important;
    }

    cart-drawer .cart-item__image {
      width: 76px !important;
      max-width: 76px !important;
      height: 76px !important;
    }

    cart-drawer .drawer__footer {
      padding: 13px 13px 15px !important;
    }

    cart-items .title-wrapper-with-link {
      align-items: flex-start !important;
      margin-bottom: 16px !important;
    }

    cart-items .title.title--primary {
      font-size: 31px !important;
    }

    cart-items .underlined-link {
      padding-top: 4px;
      font-size: 10px !important;
    }

    cart-items .cart-item {
      grid-template-columns: 86px minmax(0,1fr) auto !important;
      grid-template-areas:
        "media details total"
        "media quantity quantity" !important;
      gap: 8px 10px !important;
      margin-bottom: 10px !important;
      padding: 11px !important;
      border-radius: 12px;
    }

    cart-items .cart-item__media,
    cart-items .cart-item__image-container {
      width: 86px !important;
    }

    cart-items .cart-item__image-container {
      height: 86px !important;
      border-radius: 9px !important;
    }

    cart-items .cart-item__name {
      font-size: 12px !important;
    }

    cart-items .product-option {
      font-size: 9px !important;
    }

    cart-items .cart-item__price-wrapper .price,
    cart-items .cart-item__final-price {
      font-size: 11px !important;
    }

    cart-items .uss-cart-item--addon {
      width: calc(100% - 12px) !important;
      margin-left: 12px !important;
      grid-template-columns: 66px minmax(0,1fr) auto !important;
      padding: 9px !important;
    }

    cart-items .uss-cart-item--addon .cart-item__media,
    cart-items .uss-cart-item--addon .cart-item__image-container {
      width: 66px !important;
    }

    cart-items .uss-cart-item--addon .cart-item__image-container {
      height: 66px !important;
    }

    #main-cart-footer .cart__blocks {
      width: 100% !important;
      padding: 16px !important;
      border-radius: 14px;
    }

    .uss-gear-carousel {
      --uss-card-width: 140px;
      margin-top: 18px;
      padding: 15px 11px;
      border-radius: 13px;
    }

    cart-drawer .uss-gear-carousel {
      --uss-card-width: 118px;
    }

    .uss-gear-carousel__heading h2 {
      font-size: 16px;
    }
  }
  `;

  function injectStyles() {
    if (document.getElementById('uss-cart-revamp-styles')) return;
    const style = document.createElement('style');
    style.id = 'uss-cart-revamp-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function money(value) {
    const num = Number(value);
    const currency =
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      'USD';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(num);
    } catch {
      return '$' + num.toFixed(2);
    }
  }

  function productHandleFromHref(href) {
    if (!href) return '';
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch {
      return '';
    }
  }

  function getCartProductHandles() {
    const handles = new Set();
    document.querySelectorAll(
      'cart-drawer .cart-item__name[href], cart-items .cart-item__name[href]'
    ).forEach((a) => {
      const handle = productHandleFromHref(a.getAttribute('href'));
      if (handle) handles.add(handle);
    });
    return handles;
  }

  async function loadGearProducts() {
    if (USS_CART.gearProducts) return USS_CART.gearProducts;

    try {
      const res = await fetch(
        `/collections/${USS_CART.gearHandle}/products.json?limit=20`,
        { credentials: 'same-origin' }
      );

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      const products = Array.isArray(data.products) ? data.products : [];

      USS_CART.gearProducts = products;
      USS_CART.gearHandleSet = new Set(products.map((p) => p.handle));

      return products;
    } catch (err) {
      console.warn('[UsedSkateShop cart] Could not load hockey gear:', err);
      USS_CART.gearProducts = [];
      return [];
    }
  }

  function findAssociationText(item) {
    const text = item.innerText || '';
    const match = text.match(
      /(?:Added with skate|Upgrade for)\s*:\s*([^\n]+)/i
    );
    return match ? match[1].trim() : '';
  }

  function removeAssociationPropertyRows(item) {
    item.querySelectorAll('.product-option').forEach((el) => {
      const text = (el.textContent || '').trim();
      if (/^(Added with skate|Upgrade for)\s*:/i.test(text)) {
        el.remove();
      }
    });
  }

  function addAddonBadge(item, associatedWith) {
    const details = item.querySelector('.cart-item__details');
    if (!details || details.querySelector('.uss-cart-addon-badge')) return;

    const badge = document.createElement('span');
    badge.className = 'uss-cart-addon-badge';
    badge.textContent = 'Skate add-on';

    const title = details.querySelector('.cart-item__name');
    if (title) title.insertAdjacentElement('afterend', badge);
    else details.prepend(badge);

    if (associatedWith) {
      const sub = document.createElement('small');
      sub.className = 'uss-cart-addon-for';
      sub.textContent = `For ${associatedWith}`;
      badge.insertAdjacentElement('afterend', sub);
    }
  }

  function classifyCartItems() {
    if (!USS_CART.gearHandleSet.size) return;

    document
      .querySelectorAll('cart-drawer .cart-item, cart-items .cart-item')
      .forEach((item) => {
        const link = item.querySelector('.cart-item__name[href]');
        const handle = productHandleFromHref(link && link.getAttribute('href'));
        const association = findAssociationText(item);

        item.classList.remove('uss-cart-item--addon', 'uss-cart-item--gear');

        if (handle && USS_CART.gearHandleSet.has(handle)) {
          item.classList.add('uss-cart-item--gear');

          if (association) {
            item.classList.add('uss-cart-item--addon');
            removeAssociationPropertyRows(item);
            addAddonBadge(item, association);
          }
        }
      });
  }

  function fixDirectCheckoutAnchors() {
    document.querySelectorAll('a.uss-cart-direct-checkout').forEach((link) => {
      link.setAttribute('href', '/checkout');
    });
  }


  function installCheckoutHandler() {
    if (document.documentElement.dataset.ussCheckoutHandler === 'true') return;
    document.documentElement.dataset.ussCheckoutHandler = 'true';

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(
        '#checkout, #CartDrawer-Checkout, .cart__checkout-button, ' +
        '#cart-notification-form button[name="checkout"], ' +
        '.cart-notification__links button[name="checkout"], ' +
        'a.uss-cart-direct-checkout'
      );

      if (!trigger) return;
      if (trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const root =
        window.Shopify &&
        Shopify.routes &&
        Shopify.routes.root
          ? Shopify.routes.root
          : '/';

      /*
        Shopify's documented checkout flow is a POST to the cart route
        containing a field named "checkout".
        We intentionally create a fresh minimal form here instead of using
        Dawn's existing cart form so no theme JavaScript, quantity fields,
        or drawer state can block the checkout request.
      */
      const checkoutForm = document.createElement('form');
      checkoutForm.method = 'post';
      checkoutForm.action = root + 'cart';
      checkoutForm.style.display = 'none';

      const checkoutField = document.createElement('input');
      checkoutField.type = 'hidden';
      checkoutField.name = 'checkout';
      checkoutField.value = 'Checkout';

      checkoutForm.appendChild(checkoutField);
      document.body.appendChild(checkoutForm);

      HTMLFormElement.prototype.submit.call(checkoutForm);
    }, true);
  }

  function upgradeDrawerHeading() {
    const heading = document.querySelector('cart-drawer .drawer__heading');
    if (!heading || heading.dataset.ussUpgraded === 'true') return;

    heading.dataset.ussUpgraded = 'true';
    const old = heading.textContent.trim();
    if (/cart/i.test(old)) heading.textContent = 'Your Cart';
  }

  function createCarousel(products, compact = false) {
    const wrap = document.createElement('section');
    wrap.className = 'uss-gear-carousel';
    if (compact) wrap.classList.add('uss-gear-carousel--compact');

    const heading = document.createElement('div');
    heading.className = 'uss-gear-carousel__heading';

    const headingText = document.createElement('div');
    const kicker = document.createElement('span');
    kicker.className = 'uss-gear-carousel__kicker';
    kicker.textContent = 'Complete your setup';

    const h2 = document.createElement('h2');
    h2.textContent = 'Hockey Gear';

    headingText.append(kicker, h2);

    const shopAll = document.createElement('a');
    shopAll.href = `/collections/${USS_CART.gearHandle}`;
    shopAll.textContent = 'Shop all';

    heading.append(headingText, shopAll);

    const track = document.createElement('div');
    track.className = 'uss-gear-carousel__track';

    const inCart = getCartProductHandles();
    let shown = 0;

    for (const product of products) {
      if (shown >= USS_CART.maxGearItems) break;
      if (!product || !product.handle || inCart.has(product.handle)) continue;

      const variants = Array.isArray(product.variants) ? product.variants : [];
      const availableVariant =
        variants.find((v) => v.available !== false) || variants[0];

      if (!availableVariant) continue;

      const card = document.createElement('a');
      card.className = 'uss-gear-carousel__card';
      card.href = `/products/${product.handle}`;

      const imageWrap = document.createElement('span');
      imageWrap.className = 'uss-gear-carousel__image';

      const imageUrl =
        (product.images && product.images[0] && product.images[0].src) ||
        product.image?.src ||
        '';

      if (imageUrl) {
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = product.title || 'Hockey gear';
        img.loading = 'lazy';
        imageWrap.appendChild(img);
      }

      const copy = document.createElement('span');
      copy.className = 'uss-gear-carousel__copy';

      const title = document.createElement('strong');
      title.textContent = product.title || 'Hockey gear';

      const price = document.createElement('span');
      price.textContent = money(availableVariant.price || 0);

      copy.append(title, price);

      const view = document.createElement('span');
      view.className = 'uss-gear-carousel__view';
      view.textContent = 'View';

      card.append(imageWrap, copy, view);
      track.appendChild(card);
      shown += 1;
    }

    if (!shown) return null;

    wrap.append(heading, track);
    return wrap;
  }

  function renderCarousels() {
    if (!USS_CART.gearProducts || !USS_CART.gearProducts.length) return;

    /* Drawer */
    const drawerItems = document.querySelector('cart-drawer cart-drawer-items');
    if (drawerItems && !drawerItems.querySelector('.uss-gear-carousel')) {
      const carousel = createCarousel(USS_CART.gearProducts, true);
      if (carousel) drawerItems.appendChild(carousel);
    }

    /* Full cart page */
    const cartItems = document.querySelector('cart-items');
    if (cartItems && !cartItems.querySelector('.uss-gear-carousel')) {
      const pageWidth = cartItems.querySelector('.page-width') || cartItems;
      const carousel = createCarousel(USS_CART.gearProducts, false);
      if (carousel) pageWidth.appendChild(carousel);
    }
  }

  function refresh() {
    USS_CART.scheduled = false;
    fixDirectCheckoutAnchors();
    upgradeDrawerHeading();
    classifyCartItems();
    renderCarousels();
  }

  function scheduleRefresh() {
    if (USS_CART.scheduled) return;
    USS_CART.scheduled = true;
    window.requestAnimationFrame(refresh);
  }

  async function init() {
    injectStyles();
    installCheckoutHandler();
    fixDirectCheckoutAnchors();
    upgradeDrawerHeading();

    await loadGearProducts();

    classifyCartItems();
    renderCarousels();

    const observer = new MutationObserver(scheduleRefresh);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('shopify:section:load', scheduleRefresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
